import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudDividerModule } from '@freud-ds/web-components';

import { ModalSidebar } from './modal-sidebar.component';

@NgModule({
	declarations: [ModalSidebar],
	imports: [CommonModule, FreudDividerModule],
	exports: [ModalSidebar],
})
export class ModalSidebarModule {}
